import { useState, useRef, useEffect } from 'react';
import { Box, Button, Text } from '@primer/react';
import { CaretDown, CaretUp } from 'phosphor-react';
import clsx from 'clsx';

interface AccordionProps {
  title: any;
  children: React.ReactNode;
  wrapperClassName?: string;
  onClick?: () => void;
  onToggle?: (isOpen: boolean) => void;
}

const Accordion = ({ title, children, wrapperClassName, onClick, onToggle }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleAccordion = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    if (onClick) {
      onClick();
    }
    if (onToggle) {
      onToggle(newIsOpen);
    }
  };

  useEffect(() => {
    if (isOpen && contentRef.current) {
      contentRef.current.focus();
    }
  }, [isOpen]);

  return (
    <Box className={clsx('', wrapperClassName)}>
      <Button
        leadingVisual={isOpen ? CaretUp : CaretDown}
        variant={onToggle ? 'default' : 'invisible'}
        onClick={toggleAccordion}
        aria-expanded={isOpen}
        block={onToggle ? true : false}
      >
        <Text>{title}</Text>
      </Button>
      {isOpen && (
        <Box mt={2} ref={contentRef} tabIndex={-1}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default Accordion;
